import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resourceTypeAction } from "../redux/resourceType-slice";
import useHttps from "./useHttps";
import useReporting from "./useReporting";

const useResourceTypes = () => {
   const { sendRequest } = useHttps();
   const dispatch = useDispatch();
   const { apiErrorReportingService, reportingService } = useReporting();
   const [openDialog, setOpenDialog] = useState(false);
   const [singleResourceType, setResourceType] = useState(null);

   const closeDeleteDialog = () => {
      setOpenDialog(false);
      dispatch(resourceTypeAction.setSingleResourceType({}));
   };

   const openDeleteDialog = () => {
      setOpenDialog(true);
   };

   const {
      resourceType: { resourceType, resourceTypeResponse },
   } = useSelector((state) => state);

   const getResourcesTypeSuccess = (data) => {
      dispatch(resourceTypeAction.setResourceTypeResponse(data?.data));
   };

   const openResourceTypeForm = () => {
      dispatch(resourceTypeAction.setOpenForm(true));
   };

   const createResourceTypeLoaderFunc = (value) => {
      dispatch(resourceTypeAction.setCreateLoading(value));
   };

   const getResourceTypeLoaderFunc = (value) => {
      dispatch(resourceTypeAction.setGetLoading(value));
   };

   const searchResourceType = (value) => {
      const searchValue = value ? `name:${value.trim()}*` : "";

      getResourceTypes({ pageSize: 10, pageNo: 0, search: searchValue });
   };

   const getResourceTypes = useCallback(
      ({ pageSize = 10, pageNo = 0, sortBy = "id", search = "" }) => {
         const config = {
            method: "get",
            url: `resource/get-resource-types?pageSize=${pageSize}&pageNo=${pageNo}&sortBy=${sortBy}&search=${search}`,
         };

         sendRequest(
            config,
            getResourcesTypeSuccess,
            getResourceTypeLoaderFunc,
            getResourceError
         );
      },
      [sendRequest]
   );

   const onSetResourceType = (resource) => {
      const resourceType =
         resourceTypeResponse?.content?.find(
            (type) => type.id === resource.resourceTypeId
         ) ?? null;
      return resourceType;
   };

   const getResourceError = (response) => {
      apiErrorReportingService(response);
      dispatch(resourceTypeAction.setResourceTypeResponse({}));
   };

   const addResourceTypeSuccess = () => {
      closeResourceTypeForm();
      reportingService("Resource updated Successfully", "success");
      const pageSize = resourceTypeResponse?.pageable?.pageSize ?? 10;
      const pageNo = resourceTypeResponse?.pageable?.pageNumber ?? 0;
      getResourceTypes({ pageSize, pageNo });
   };

   const closeResourceTypeForm = () => {
      dispatch(resourceTypeAction.setSingleResourceType({}));
      dispatch(resourceTypeAction.setOpenForm(false));
   };

   const deleteResourceType = () => {
      closeDeleteDialog();
      const config = {
         url: `resource/remove-resource-type/${resourceType.id}`,
         method: "delete",
      };
      sendRequest(
         config,
         addResourceTypeSuccess,
         getResourceTypeLoaderFunc,
         apiErrorReportingService
      );
   };
   const addResourceType = useCallback(
      (body) => {
         const config = {
            data: body,
            url: `resource/create-update-resource-type`,
            method: "post",
         };

         sendRequest(
            config,
            addResourceTypeSuccess,
            createResourceTypeLoaderFunc,
            apiErrorReportingService
         );
      },
      [sendRequest, resourceTypeResponse]
   );
   return {
      addResourceType,
      deleteResourceType,
      openResourceTypeForm,
      openDialog,
      openDeleteDialog,
      closeResourceTypeForm,
      closeDeleteDialog,
      getResourceTypes,
      singleResourceType,
      onSetResourceType,
      setResourceType,
      searchResourceType,
   };
};

export default useResourceTypes;
